<template>
<div>
    <div v-if="type === 'normal-card'" class="cards">
        <Card style="margin-bottom: 2em" v-for="(card, index) in cards" :key="'card-'+index" :id="card.title + index" :to="card.to">
            <template #title>
                <div class="title-flex">
                    <div class="title-flex-content">
                        <i class="pi title-icon-right" :style="card.style" :class="card.icon" v-if="card.icon" />
                    </div>
                    <div>
                        {{ card.title }}
                        <i class="pi icon-arrow title-icon-left" v-if="arrowIcon" />
                    </div>
                </div>
            </template>
            <template #content>
                <p>
                    <span class="card-custom-text">
                        {{ card.content }}
                    </span>
                </p>
            </template>
            <template #footer v-if="card.footerText">
                <p class="footerText">
                    {{ card.footerText }}
                </p>
            </template>
        </Card>
    </div>
    <div v-else>
        <div class="catalog-cards">
            <CardCatalog style="margin-bottom: 0px; margin-top: 0px;" v-for="(card, index) in cards" :key="'card-'+index" :id="card.title + index" :to="card.to">
                <template #content>
                    <div style="display: flex; gap: 25px;">
                        <div>
                            <div style="background: #43CE34; border-radius: 50px; height: 40px; width: 40px; justify-content: center; text-align:center; display: flex;
        align-items: center;">
                                <i class="pi " :class="card.icon" style="background: #F3F7F8;" :style="card.style" v-if="card.icon" />
                            </div>
                        </div>
                        <div>
                            <div style="margin-bottom: 12px; color: #0A3C45; letter-spacing: 0px; font-family: var(--font-inter-semibold)">
                                {{ card.title }}
                                <i class="pi icon-arrow title-icon-left" v-if="arrowIcon" />
                            </div>
                            <p>
                                <span class="card-custom-text" style="line-height: 20px;">
                                    {{ card.content }}
                                </span>
                            </p>
                        </div>
                    </div>
                </template>
                <template #footer v-if="card.footerText">
                    <p class="footerText">
                        {{ card.footerText }}
                    </p>
                </template>
            </CardCatalog>
        </div>
    </div>
</div>
</template>
<script>
import Card from '../Card/index.vue'
import CardCatalog from '../CardCatalog/index.vue'
export default {
    name: 'CardList',
    props: {
        cards: {
            type: Array,
            default: () => []
        },
        cardWidth: {
            type: String,
            default: '320px' // px, rem, em, etc.
        },
        arrowIcon: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'normal-card'
        }
    },
    components: {
        Card,
        CardCatalog
    }
}
</script>
<style>
.title-flex {
    display: flex;
    flex-direction: column;
    position: relative;
    top: 10px;
    gap: 18px;
}
.title-flex-content {
    width: 29px;
    max-height: 29px;
    position: relative;
    top: -2px;
}
.title-icon-right {
    width: 28px;
    height: 18px;
    margin-right: 8px;
    background: var(--iu-main) 0% 0% no-repeat padding-box;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
.title-icon-left {
    margin-left: 8px !important;
    width: 22px;
    height: 14px;
    background: var(--iu-main) 0% 0% no-repeat padding-box;
}
.card-custom-text {
    font-family: var(--font-acumin-pro-light) !important;
    font-size: 14px !important;
    letter-spacing: 0px;
    letter-spacing: -0.2px;
    color: #808184;
}
.card {
    flex: 1 0 500px;
    box-sizing: border-box;
    margin: 1rem 0.25em;
}

.footerText {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0px;
    color: #266B76;
}

@media screen and (min-width: 40em) {
    .cards {
        display: flex;
        flex-wrap: wrap;
        gap: 20px !important;
    }
    .catalog-cards {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    }
    .card {
        flex: 0 1 calc(60% - 1em);
    }
}

@media screen and (min-width: 60em) {
    .card {
        flex: 0 1 calc(31% - 0em) !important;
    }
}

</style>
